import { Component, OnInit } from '@angular/core';
import { PortalDAO } from "../../daos/portal.dao";
import { MenuService } from "../../services/menu.service";
import { PortalLink } from "../../model/interfaces/portal.interfaces";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService } from 'primeng/api';
import { LoggedUser } from "../../common/logged-user.service";

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss']
})
export class LandingComponent implements OnInit {

  public links: PortalLink[][] = [[], []];
  public items: any[];
  public username: string;

  constructor(private menuService: MenuService,
              private portalDAO: PortalDAO,
              private router: Router,
              private messageService: MessageService,
              private translocoService: TranslocoService,
              private confirmationService: ConfirmationService,
              private loggedUser: LoggedUser) {
  }

  ngOnInit(): void {
      this.items = this.menuService.getItems().slice(1);
      this.loadPortalLinks();
      this.loggedUser.userObservable.subscribe( user => this.username = user.attributes.username);
  }

  private loadPortalLinks() {
    this.portalDAO.getPortalLinks().subscribe((response) => {
          let received = response as unknown as PortalLink[];
          received.forEach(link => {
            link.color = link.color + "80";
            this.links[link.customApplication].push(link);
          });
      });
  }

  public getIcon(link:PortalLink) : string {
      return `data:image/png;base64,${link.icon}`;
  }

  public hexToRGBA(over, external, index) {
      if (over == 1) {
          this.links[external][index].color = this.links[external][index].color.substring(0,7) + 'ff';
      } else {
          this.links[external][index].color = this.links[external][index].color.substring(0,7) + '80';
      }
  }

   public confirmDeleteExternalApplication(event: Event, externalApplicationUuid: string) {
      this.confirmationService.confirm({
          target: event.target,
          message: this.translocoService.translate('delete.externalApplication.confirmation'),
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
              this.deleteExternalApplication(externalApplicationUuid);
          },
          reject: () => {
              //reject action
          }
      });
   }

   private deleteExternalApplication(externalApplicationUuid: string) {
       this.portalDAO.deleteExternalApplication(externalApplicationUuid).then(() => {
         this.messageService.add({severity: 'success',
                                          summary: this.translocoService.translate('delete.externalApplication.success.summary'),
                                          detail: this.translocoService.translate('delete.externalApplication.success.detail'),
                                          sticky: false});
         this.realoadLinks();
       }).catch(error => {
         this.messageService.add({severity: 'error',
                                  summary: this.translocoService.translate('delete.externalApplication.error.summary'),
                                  detail: this.translocoService.translate('delete.externalApplication.error.summary'),
                                  sticky: true});
       });
   }

  private realoadLinks() {
    this.links = [[],[]];
    this.loadPortalLinks();
  }

}
